import type { ReactElement } from 'react';
import { IconAlertCircle } from '@tabler/icons-react';
import { ButtonPreset } from '@/constants/componentPresets';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import type { AuthError } from '@/types/auth-types';
import { Cbutton } from '../Cbutton';
import { Cicon } from '../Cicon';
import { Ctext } from '../Ctext';
const FALLBACK_AUTH_ERROR_TITLE = 'Authentication Error';
const FALLBACK_AUTH_ERROR_MESSAGE = 'Something went wrong. Please try again.';
interface ErrorAuthBodyProps {
    error: AuthError | null;
    onRetry: () => void;
}
function getAuthErrorTitle(error: AuthError | null): string {
    if (!error?.title)
        return FALLBACK_AUTH_ERROR_TITLE;
    return error.title;
}
function getAuthErrorMessage(error: AuthError | null): string {
    if (!error?.message)
        return FALLBACK_AUTH_ERROR_MESSAGE;
    return error.message;
}
export function ErrorAuthBody({ error, onRetry }: ErrorAuthBodyProps): ReactElement {
    return (
      <div data-el="Cauthmodal/ErrorAuthBody/Root" key="error" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '24px',
            textAlign: 'center',
        }}>
        <Cicon icon={IconAlertCircle} size={64} color={ColorType.Accent} opacity={0.8}/>
        <Ctext size={24} weight={FontWeight.Bold} color={ColorType.White}>
          {getAuthErrorTitle(error)}
        </Ctext>
        <Ctext size={16} weight={FontWeight.Regular} color={ColorType.White} opacity={0.8}>
          {getAuthErrorMessage(error)}
        </Ctext>
        <Cbutton preset={ButtonPreset.Secondary} onClick={onRetry} style={{ marginTop: '16px' }}>
          <Ctext size={16} weight={FontWeight.Medium} color={ColorType.White}>
            Try Again
          </Ctext>
        </Cbutton>
      </div>
    );
}
